import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broadcastings-broadcasting-schedule',
  templateUrl: './broadcastings-broadcasting-schedule.component.html',
  styleUrls: ['./broadcastings-broadcasting-schedule.component.scss']
})
export class BroadcastingsBroadcastingScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
